import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { reduxForm, Field } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import Button from 'components/common/Button';
import EditTextField from 'components/fields/EditTextField';
import SwitchField from 'components/fields/SwitchField';

import * as validate from 'utils/validate';

import SchedulePreviewEditFormField from './SchedulePreviewEditFormField';

const styles = () => ({
  paper: {
    overflow: 'hidden',
    marginTop: 24,
  },
  button: {
    marginLeft: 24,
  },
  table: {
    tableLayout: 'fixed',
  },
  tableRow: {
    '&:last-child td': {
      borderBottom: 'none',
    },
  },
  tableCellHead: {
    paddingLeft: 15,
    paddingRight: 15,
    '&:first-child': {
      paddingLeft: 15,
    },
  },
  tableCellTimeOfDelivery: {
    width: 60,
    maxWidth: 60,
  },
  tableCellZip: {
    width: 40,
    maxWidth: 40,
  },
  tableCellPhone: {
    width: 95,
    maxWidth: 95,
  },
});

const SchedulePreviewEditForm = ({
  handleSubmit,
  schedule,
  submitting,
  submit,
  onCancelButtonClick,
  classes,
}) => (
  <form
    noValidate
    onSubmit={handleSubmit}
    autoComplete="off"
  >
    <Toolbar
      className={classes.gridToolbar}
      disableGutters
    >
      <Grid
        container
        spacing={24}
        alignItems="center"
        justify="space-between"
      >
        <Grid item>
          <Field
            name="Name"
            component={EditTextField}
            placeholder="Print Document Name"
            validate={[validate.required]}
          />
        </Grid>
        <Grid item>
          <Field
            className={classes.switchField}
            id="Save Comments"
            name="Save Comments"
            label="Save new comments in Chart"
            component={SwitchField}
          />
          <Button
            variant="raised"
            className={classes.button}
            onClick={onCancelButtonClick}
          >
            Cancel
          </Button>
          <Button
            variant="raised"
            color="primary"
            className={classes.button}
            disabled={submitting}
            onClick={submit}
          >
            Print
          </Button>
        </Grid>
      </Grid>
    </Toolbar>
    <Paper className={classes.paper}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell
              className={classNames(classes.tableCellHead, classes.tableCellTimeOfDelivery)}
            >
              Time
            </TableCell>
            <TableCell className={classes.tableCellHead}>Patient Name</TableCell>
            <TableCell className={classes.tableCellHead}>Address</TableCell>
            <TableCell className={classes.tableCellHead}>City</TableCell>
            <TableCell
              className={classNames(classes.tableCellHead, classes.tableCellZip)}
            >
              Zip
            </TableCell>
            <TableCell
              className={classNames(classes.tableCellHead, classes.tableCellPhone)}
            >
              Phone
            </TableCell>
            <TableCell className={classes.tableCellHead}>Products</TableCell>
            <TableCell className={classes.tableCellHead}>Comments</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {schedule.map(item => (
            <TableRow
              className={classes.tableRow}
              key={item.ID}
            >
              <SchedulePreviewEditFormField
                name={`schedule-${item.ID}.timeOfDelivery`}
                className={classes.tableCellTimeOfDelivery}
              />
              <SchedulePreviewEditFormField
                name={`schedule-${item.ID}.patientName`}
              />
              <SchedulePreviewEditFormField
                name={`schedule-${item.ID}.address`}
              />
              <SchedulePreviewEditFormField
                name={`schedule-${item.ID}.city`}
              />
              <SchedulePreviewEditFormField
                name={`schedule-${item.ID}.zip`}
                className={classes.tableCellZip}
              />
              <SchedulePreviewEditFormField
                name={`schedule-${item.ID}.phone`}
                className={classes.tableCellPhone}
              />
              <SchedulePreviewEditFormField
                name={`schedule-${item.ID}.products`}
              />
              <SchedulePreviewEditFormField
                name={`schedule-${item.ID}.comments`}
              />
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  </form>
);

SchedulePreviewEditForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  schedule: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.string.isRequired,
  })).isRequired,
  onCancelButtonClick: PropTypes.func,
  classes: PropTypes.shape({
    paper: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    tableRow: PropTypes.string.isRequired,
    tableCellHead: PropTypes.string.isRequired,
    tableCellTimeOfDelivery: PropTypes.string.isRequired,
    tableCellZip: PropTypes.string.isRequired,
    tableCellPhone: PropTypes.string.isRequired,
  }).isRequired,
};

SchedulePreviewEditForm.defaultProps = {
  onCancelButtonClick: () => {},
};

export default reduxForm()(
  withStyles(styles)(SchedulePreviewEditForm),
);



// WEBPACK FOOTER //
// ./src/components/schedule/SchedulePreviewEditForm/SchedulePreviewEditForm.js